//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Mobile from '@/components/Mobile.vue'
/*eslint-disable */
var browser = {
  versions: function() {
      var a = navigator.userAgent;
      return {
          trident: a.indexOf('Trident') > -1,
          presto: a.indexOf('Presto') > -1,
          webKit: a.indexOf('AppleWebKit') > -1,
          gecko: a.indexOf('Gecko') > -1 && a.indexOf('KHTML') == -1,
          mobile: !! a.match(/AppleWebKit.*Mobile.*/),
          ios: !! a.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: a.indexOf('Android') > -1,
          iPhone: a.indexOf('iPhone') > -1,
          iPad: a.indexOf('iPad') > -1,
          webApp: a.indexOf('Safari') == -1,
          appbyme: a.indexOf('Appbyme') > -1
      }
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
/*eslint-enable */
export default {
  data () {
    return {
      bannerList: [
        'http://img.luckytype.com/portal/banner1a.png',
        'http://img.luckytype.com/portal/banner3.png',
        'http://img.luckytype.com/portal/banner4.png'
      ],
      zhaopaiList: [
        'http://img.luckytype.com/portal/zhaopai1.png',
        'http://img.luckytype.com/portal/zhaopai2.png',
        'http://img.luckytype.com/portal/zhaopai3.png',
        'http://img.luckytype.com/portal/zhaopai3a.png',
        'http://img.luckytype.com/portal/zhaopai4.png',
        'http://img.luckytype.com/portal/zhaopai5.png',
        'http://img.luckytype.com/portal/zhaopai6.png',
        'http://img.luckytype.com/portal/zhaopai7.png',
        'http://img.luckytype.com/portal/zhaopai8.png',
        'http://img.luckytype.com/portal/zhaopai9.png'
      ],
      ledunList: [
        'http://img.luckytype.com/portal/ledun1.png',
        'http://img.luckytype.com/portal/ledun2.png',
        'http://img.luckytype.com/portal/ledun3.png',
        'http://img.luckytype.com/portal/ledun4.png',
        'http://img.luckytype.com/portal/ledun5.png',
        'http://img.luckytype.com/portal/ledun6.png',
        'http://img.luckytype.com/portal/ledun7.png',
        'http://img.luckytype.com/portal/ledun8.png',
        'http://img.luckytype.com/portal/ledun9.png'
      ],
      juzhenList: [
        'http://img.luckytype.com/portal/juzhen1.png',
        'http://img.luckytype.com/portal/juzhen2.png',
        'http://img.luckytype.com/portal/juzhen3.png',
        'http://img.luckytype.com/portal/juzhen4.png',
        'http://img.luckytype.com/portal/juzhen5.png',
        'http://img.luckytype.com/portal/juzhen6.png',
        'http://img.luckytype.com/portal/juzhen7.png'
      ],
      shanlinList: [
        'http://img.luckytype.com/portal/shanlin1.png',
        'http://img.luckytype.com/portal/shanlin2.png',
        'http://img.luckytype.com/portal/shanlin3.png',
        'http://img.luckytype.com/portal/shanlin4.png',
        'http://img.luckytype.com/portal/shanlin5.png',
        'http://img.luckytype.com/portal/shanlin6.png',
        'http://img.luckytype.com/portal/shanlin7.png',
        'http://img.luckytype.com/portal/shanlin8.png',
        'http://img.luckytype.com/portal/shanlin9.png'
      ],
      isAndroid: false,
      isIphone: false,
      isPC: false
    }
  },
  components: {
    Mobile
  },
  mounted () {
    if (browser.versions.iPhone) {
      this.isIphone = true
    } else if (browser.versions.android) {
      this.isAndroid = true
    } else {
      this.isPC = true
    }
  },
  updated () {
    setTimeout(() => {
      // 跳转
      window.location.href = 'https://xiquezaozi.taobao.com'
      // window.location.href = 'https://item.taobao.com/item.htm?spm=a1z10.3-c-s.w4002-21126585920.9.4f2128faoF21Ka&id=563405060677'
    }, 100)
  },
  methods: {
    onBuy (val) {
      if (val === 'zhaopai') {
        open('https://item.taobao.com/item.htm?spm=a230r.1.14.1.21e85e41CPNqVN&id=563405060677&ns=1&abbucket=15#detail')
      } else if (val === 'ledun') {
        open('https://item.taobao.com/item.htm?spm=a230r.1.14.12.21e85e41CPNqVN&id=563406620962&ns=1&abbucket=15#detail')
      } else if (val === 'juzhen') {
        open('https://item.taobao.com/item.htm?spm=a230r.1.14.23.21e85e41CPNqVN&id=563576458770&ns=1&abbucket=15#detail')
      } else if (val === 'zaishanlin') {
        open('https://item.taobao.com/item.htm?spm=a230r.1.14.18.21e85e41CPNqVN&id=563577006791&ns=1&abbucket=15#detail')
      } else if (val === 'vip') {
        open('https://item.taobao.com/item.htm?spm=a230r.1.14.7.21e85e41CPNqVN&id=563509473751&ns=1&abbucket=15#detail')
      }
    },
    toBeiAn () {
      open('https://beian.miit.gov.cn/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.vue